export enum PatientObservationType {
  ANTECEDENTS = 'Antecedents',
  BEHAVIOURS = 'Behaviours',
  DIAGNOSTICS = 'Diagnostics',
  MANIFESTATIONS = 'Manifestations',
  NOSOLOGICAL_FRAMEWORKS = 'NosologicalFrameworks',
  RISKS = 'Risks',
  SUSPICIONS = 'Suspicions',
}
